export default __webpack_public_path__ + "static/media/5.41dfc796.jpg";